var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/CategoryBlue.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CategoryBlue = ({
  color = '#4C5ECF',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("rect", {
    opacity: "0.1",
    width: "24",
    height: "24",
    rx: "4",
    fill: "#2235AA"
  }), /*#__PURE__*/_jsx("rect", {
    opacity: "0.5",
    x: "5",
    y: "13",
    width: "6",
    height: "6",
    rx: "1",
    fill: color
  }), /*#__PURE__*/_jsx("rect", {
    opacity: "0.5",
    x: "5",
    y: "5",
    width: "6",
    height: "6",
    rx: "3",
    fill: color
  }), /*#__PURE__*/_jsx("path", {
    opacity: "0.5",
    d: "M13.7217 11H18.2778C19.0457 11 19.526 10.1705 19.1451 9.50386L16.8682 5.51943C16.4843 4.84761 15.5157 4.84761 15.1318 5.51943L12.8549 9.50386C12.474 10.1705 12.9538 11 13.7217 11Z",
    fill: color
  }), /*#__PURE__*/_jsx("rect", {
    opacity: "0.5",
    x: "12.0713",
    y: "16",
    width: "5.6066",
    height: "5.6066",
    rx: "1",
    transform: "rotate(-45 12.0713 16)",
    fill: color
  })]
});